import { useModal } from 'app/context/Modal';
import { checkIsAuthorizedAction } from 'app/utils/check-is-authorized-action';
import { _t } from 'app/utils/i18n';
import { constants, getFromLocalStorage } from 'app/utils/localStorage';
import React, { FunctionComponent, useContext, useEffect, useRef } from 'react';
import { Redirect, Switch, useHistory, useLocation } from 'react-router-dom';
import AuthRoute from '../guards/AuthRoute';
import { DarkModeContext } from 'app/context/DarkModeContext';

interface Props {
  routes: any;
}
const Router: FunctionComponent<Props> = ({ routes }) => {
  const location = useLocation();
  const history = useHistory();
  const modal = useModal();
  const oldPath = useRef<any>();

  const goBackHandler = () => {
    history.push(oldPath.current);

    modal.show({
      isAlternative: true,
      message: _t(`basic:you_are_not_authorize`),
    });
  };
  const { darkMode, darkToggle } = useContext<any>(DarkModeContext);
  if (darkMode === false && getFromLocalStorage('DARK_MODE') === true) {
    darkToggle(true);
  } else if (darkMode === true && getFromLocalStorage('DARK_MODE') === null) {
    darkToggle(false);
  }
  const excludeKeys = ['AUTH', 'ANALYZING', 'SETTINGS'];
  useEffect(() => {
    const modules = getFromLocalStorage(constants.AUTHORIZED_MODULES);
    const moduleName = location.pathname.split('/');
    const module1: any = moduleName?.[1]?.toUpperCase();
    const module2: any = moduleName?.[2]?.toUpperCase();

    if (modules === null || modules?.length === 0) {
      return;
    }

    if (
      excludeKeys.includes(module1) ||
      module2 === 'USER-PROFILE' ||
      module2 == 'EDIT-PROFILE' ||
      module2 == 'RELEASE-NOTES' ||
      module2 == 'RELEASE-NOTES-DETAILS'
    )
      return;
    if (history?.action !== 'PUSH' && !checkIsAuthorizedAction(module1)) {
      history.push('/401');
      history.go(0);
      return;
    }

    if (checkIsAuthorizedAction(module1)) {
      oldPath.current = location.pathname;
      return;
    }

    goBackHandler();
  }, [location]);
  return (
    <Switch>
      {routes.map((AppRoute: any) => {
        if (AppRoute.redirect) {
          const path =
            location.pathname === '/'
              ? getFromLocalStorage(constants.LANDING_PAGE) || '/dashboard/all'
              : '/404';
          return <Redirect key={path} to={path} />;
        }
        return (
          <AuthRoute
            exact={AppRoute.exact}
            strict
            key={AppRoute.path}
            path={AppRoute.path}
            component={AppRoute.component}
            rest={[]}
          />
        );
      })}
    </Switch>
  );
};

export default Router;
